import React, { useContext, useState, Dispatch, SetStateAction } from 'react';

type TMessageData = {
  showMessage: boolean,
  message: string,
  showToast: boolean,
  toast: string,
  timeout: number
}
export const initialMessageData:TMessageData = {
  showMessage: false, 
  message: '',
  showToast: false,
  toast: '',
  timeout: 1000
}

type TMessageContext = {
  messageData: TMessageData,
  setMessageData: Dispatch<SetStateAction<TMessageData>> | null
}
export const MessageContext = React.createContext<TMessageContext>({messageData: initialMessageData, setMessageData: null})

type MessageProps = {
  init: TMessageData,
  children: React.ReactNode
}
export const MessageProvider = ({ init, children }: MessageProps) => {
  const [messageData, setMessageData] = useState(init)
  const value = React.useMemo(() => {return {messageData, setMessageData}}, [messageData])
  return <MessageContext.Provider value={value} children={children} />
}

// Hook
export const useMessage = () => {
  const context = useContext(MessageContext)
  if (!context) { throw new Error(`useMessage must be used within a MessageProvider`)}
  const {messageData, setMessageData} = context
  if (!messageData || !setMessageData) { throw new Error(`useMessage must be used within a MessageProvider`)}

  const sendMessage = (msg: string) => {
    setMessageData({
      ...messageData,
      message: msg,
      showMessage: true
    })
  }

  const clearMessage = () => {
    setMessageData({
      ...messageData,
      showMessage: false
    })
  }

  const sendToast = (msg: string) => {
    setMessageData({
      ...messageData,
      toast: msg,
      showToast: true
    })

    setTimeout(() => {
      setMessageData({
        ...messageData,
        showToast: false
      })
    }, messageData.timeout);
  }

  const setTimeoutTime = (time: number) => {
    setMessageData({
      ...messageData,
      timeout: time
    })
  }

  return {
    ...messageData,
    setTimeoutTime,
    sendMessage,
    clearMessage,
    sendToast,
  }
}
